import { useEffect, useState } from 'react';

const API_ENDPOINT = process.env.NEXT_PUBLIC_API_ENDPOINT;

type Props = {
  productSlug: string;
};

export default function PriceInfo({ productSlug }: Props): JSX.Element {
  const [price, setPrice] = useState(0);
  const [fee, setFee] = useState(0);

  useEffect(() => {
    const fetchProduct = async () => {
      const res = await fetch(`${API_ENDPOINT}/products/${productSlug}`);
      const json = await res.json();

      if (json.success) {
        const { price, fee } = json.data;
        setPrice(price);
        setFee(fee);
      }
    };
    fetchProduct();
  }, []);

  return (
    <div className="bg-box-background border-2 border-box-border w-full md:min-w-24 md:w-1/3 lg:w-1/4 h-1/3">
      <h3 className="bg-box-header text-center text-xl leading-8 font-medium tracking-tight text-white items-center mb-5 py-2 px-4">
        Pricing
      </h3>
      <p className="text-6xl text-center font-medium tracking-tight items-center mb-5 py-2 px-4">
        £{price}
      </p>
      <div className="flex p-2 justify-between px-10 md:px-2">
        <span className="text-lg text-center tracking-tight items-center">
          Government Fees
        </span>
        <span className="text-lg text-center tracking-tight items-center">
          £{fee}
        </span>
      </div>
      <div className="flex p-2 justify-between px-10 md:px-2">
        <p className="text-lg text-center tracking-tight items-center">
          License Assistance
        </p>
        <span className="text-lg text-center tracking-tight items-center">
          £{price - fee}
        </span>
      </div>
    </div>
  );
}
